// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2lKMW","rootCenter":"LoadMoreObserver_rootCenter__3wAOu","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__WsM0L"};